
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/socios/[slug]",
      function () {
        return require("private-next-pages/socios/[slug].js");
      }
    ]);
  